/**
 * The notes pinned to the bottom-left of the Costing / Pricing cards
 * (dev-sync G / UF-1, costing.tmpl:1112-1114).
 *
 * The wrapper is taken out of the flow by
 * `.footer-note-wrapper { position:absolute; bottom:20px }` and sits in the
 * bottom padding `.costing-content-item` reserves on the card, so the card has
 * to carry that class whenever a note renders -- and `two-footer-notes` /
 * `three-footer-notes` on top of it for a second and third line, each of which
 * needs another line's worth of padding or the notes overlap the last row.
 * `footerNoteClasses` picks them. The exact class names matter: the CSS ships in
 * the merged project/styles.css (and its sass source,
 * django/project/static/project/css/sass/tabs/_pricing_costing.scss).
 */

/** Shown on both tabs when any AHU in the project has a coil whose selected
 * model is Modine's (`has_modine_coil` in the costing/pricing celery
 * payloads). The leading line on Costing, above the Project Cost note; the
 * only line on Pricing. The Pricing PDF prints the same sentence, from
 * `MODINE_COIL_COST_NOTE` in ahu/models_component_coil.py — change both. */
export const MODINE_COIL_NOTE =
  'Contact your administrator for verification of all Modine coil costing, ' +
  'in particular Modine copper fin coil costing.';

/** Shown on both tabs when a material in the project is priced from a zero unit
 * cost — the cost in the CMS, or the one a vendor API returned
 * (`has_zero_cost_material` in the costing/pricing celery payloads). It is the
 * note above the last one, as asked: between the Modine note and the Project Cost note on
 * Costing, above the Modine note on Pricing, which has no standing note of its
 * own. The Pricing PDF and the CA Materials CSV print the same sentence, from
 * `ZERO_COST_MATERIAL_NOTE` in django/ahu/material_costs.py — change both. */
export const ZERO_COST_MATERIAL_NOTE =
  'One or more materials have a zero cost. ' +
  'Contact your Administrator for more information.';

/** Costing's own note (`ae0c2c9719`); always its last line. */
export const PROJECT_COST_NOTE =
  'Project Cost includes all "Main" Air Handling Units and no versions.';

/** The classes the card needs to make room for `notes` in its bottom padding:
 * 55px for one line, then ~20px per line after it. */
export const footerNoteClasses = (notes: string[]): string => {
  if (notes.length === 0) return '';
  if (notes.length === 1) return ' costing-content-item';
  return notes.length === 2
    ? ' costing-content-item two-footer-notes'
    : ' costing-content-item three-footer-notes';
};

const FooterNotes = ({ notes }: { notes: string[] }) => {
  if (notes.length === 0) return null;
  return (
    <div className="col-xs-12 footer-note-wrapper">
      {notes.map((note) => (
        <span className="footer-note" key={note}>
          {note}
        </span>
      ))}
    </div>
  );
};

export default FooterNotes;
